/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
  })
  $('#sp-menu-open').on('click', function() {
    $('body').toggleClass('lock')
  })
  $('.js-click-tokyo').on('click', function() {
    $('.js-click-omiya,.js-click-tokyo,.contents').addClass('active')
  })
  $('.js-click-omiya').on('click', function() {
    $('.js-click-omiya,.js-click-tokyo,.contents').removeClass('active')
  })
  // ##     ## ########    ###    ########  ######## ########
  // ##     ## ##         ## ##   ##     ## ##       ##     ##
  // ##     ## ##        ##   ##  ##     ## ##       ##     ##
  // ######### ######   ##     ## ##     ## ######   ########
  // ##     ## ##       ######### ##     ## ##       ##   ##
  // ##     ## ##       ##     ## ##     ## ##       ##    ##
  // ##     ## ######## ##     ## ########  ######## ##     ##
  // FAQ - アコーディオン
  $('.js-sp-pulldown').on('click', function() {
    $(this).toggleClass('active')
    $(this)
      .next()
      .slideToggle()
  })

  if ($('.H-swiper-container')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const hSwiper = new Swiper('.H-swiper-container', {
      navigation: {
        nextEl: '.hswiper-button-next',
        prevEl: '.hswiper-button-prev'
      }
    })
    // Initialize slider
    hSwiper.init()
  }

  //#     ## ##     ##
  //##   ### ##     ##
  //### #### ##     ##
  //# ### ## ##     ##
  //#     ##  ##   ##
  //#     ##   ## ##
  //#     ##    ###
  if ($('.MVswiper-container')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('.MVswiper-container', {
      init: false,
      loop: true,
      speed: 1000,
      slidesPerView: 3, // or 'auto'
      spaceBetween: 20, //スライド同士の間隔を空ける
      // spaceBetween: 10,
      centeredSlides: true,
      // slideToClickedSlide: true,
      // clickable: true,
      simulateTouch: false, //スワイパーの要素がつかめなくなる
      effect: 'coverflow', // 'cube', 'fade', 'coverflow',
      coverflowEffect: {
        // rotate: 50, // Slide rotate in degrees
        stretch: 0, // Stretch space between slides (in px)
        depth: 100, // Depth offset in px (slides translate in Z axis)
        modifier: 0, // Effect multipler
        slideShadows: false // これで影付けられる
      },
      autoplay: {
        delay: 4000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      grabCursor: false,
      parallax: true,
      pagination: {
        el: '.MVswiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        1000: {
          slidesPerView: 5,

          spaceBetween: 70
        }
      }
    })
    // Initialize slider
    mvSwiper.init()
  }
  // $('.head-li').hover(function() {
  //   $(this).toggleClass('active')
  //   $(this)
  //     .children('.HideMenu')
  //     .slideToggle('fast')
  // })
  //#####     ###    ########  ######## ######## ########
  //#    ##   ## ##   ##     ## ##       ##       ##     ##
  //#        ##   ##  ##     ## ##       ##       ##     ##
  //#       ##     ## ########  ######   ######   ########
  //#       ######### ##   ##   ##       ##       ##   ##
  //#    ## ##     ## ##    ##  ##       ##       ##    ##
  //#####  ##     ## ##     ## ######## ######## ##     ##
  if ($('.swiper-container')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('.swiper-container', {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      slidesPerView: 1, //表示数変更
      spaceBetween: 0, //スライド同士の間隔を空ける
      autoplay: {
        delay: 50000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        // 指定px以下時にオプション切り替え
        768: {
          slidesPerView: 1 //表示数変更
        }
      }
    })
  }
  // ########    ###    ########  ######## #### ##    ##
  // ##         ## ##   ##     ## ##        ##  ###   ##
  // ##        ##   ##  ##     ## ##        ##  ####  ##
  // ######   ##     ## ##     ## ######    ##  ## ## ##
  // ##       ######### ##     ## ##        ##  ##  ####
  // ##       ##     ## ##     ## ##        ##  ##   ###
  // ##       ##     ## ########  ######## #### ##    ##
  $(window).scroll(function() {
    $('.fadein,.fadein2,.fadein3,.fadein4,.fadein-left').each(function() {
      var position = $(this).offset().top
      var scroll = $(window).scrollTop() //スクロールした量を計測して変数に代入
      var windowHeight = $(window).height() //ウィンドウの高さを取得して代入する
      if (scroll > position - windowHeight + 50) {
        //スクロールした分＞（下から出す要素の高さ-ウィンドウの高さ）＋位置の調整
        $(this).addClass('active') //超過したときに.fadeinクラスにactiveを追加
      }
    })
  })
  // ########  ####  ######  ######## ##     ## ########  ########
  // ##     ##  ##  ##    ##    ##    ##     ## ##     ## ##
  // ##     ##  ##  ##          ##    ##     ## ##     ## ##
  // ########   ##  ##          ##    ##     ## ########  ######
  // ##         ##  ##          ##    ##     ## ##   ##   ##
  // ##         ##  ##    ##    ##    ##     ## ##    ##  ##
  // ##        ####  ######     ##     #######  ##     ## ########
  $('.js-click-btn').on('click', function() {
    const target = $(this).data('picture')
    // console.log(target)
    $('.js-click-btn').removeClass('active')
    $(this).addClass('active')
    $('.js-toggle-movie').removeClass('active')
    $('.js-toggle-movie.' + target).addClass('active')
  })
  // ########    ###     #######
  // ##         ## ##   ##     ##
  // ##        ##   ##  ##     ##
  // ######   ##     ## ##     ##
  // ##       ######### ##  ## ##
  // ##       ##     ## ##    ##
  // ##       ##     ##  ##### ##
  $('.js-change-detail').on('click', function() {
    const target = $(this).data('employ')
    // console.log(target)
    $('.js-change-detail').removeClass('active')
    $(this).addClass('active')
    $('.js-toggle-faq').removeClass('active')
    $('.js-toggle-faq.' + target).addClass('active')
  })
  // FAQ - アコーディオン
  $('.js-que-click').on('click', function() {
    $(this).toggleClass('active')
    $(this)
      .next()
      .slideToggle()
  })
  // ##     ##  #######  ########     ###    ##
  // ###   ### ##     ## ##     ##   ## ##   ##
  // #### #### ##     ## ##     ##  ##   ##  ##
  // ## ### ## ##     ## ##     ## ##     ## ##
  // ##     ## ##     ## ##     ## ######### ##
  // ##     ## ##     ## ##     ## ##     ## ##
  // ##     ##  #######  ########  ##     ## ########
  $('.js-click-modal').click(function() {
    $($(this).next('.modal-bg')).addClass('active')

    //画面の左上からmodal-mainの横幅・高さを引き、その値を2で割ると画面中央の位置が計算できます

    // ボディをロックするクラスを与える。toggleだと難しくなる
    $('body').addClass('lock')
    //中央に画像を配置するのはcssで実装
    //画像を表示
    $($(this).children('.modal-appear-img')).fadeIn('slow')
  })
  //背景をクリックしたら動画を閉じる
  $('.modal-bg').click(function() {
    //ボディからクラスをとる
    $('body').removeClass('lock')
    $('.modal-bg').removeClass('active')
    //フェードアウトさせる
    $('.modal-appear-img').fadeOut('slow', function() {
      //挿入した<div id="modal-bg"></div>を削除
    })
  })
})
